<template>
    <div class="list-users-page">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Manage hotel groups</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <!--
                        <div class="border-0 card-header">
                            <h3 class="mb-0">Light table</h3>
                        </div>
                        -->
                        <div class="card-body">
                            <base-button
                                type="primary"
                                class="mb-4"
                                @click="openHotelGroupEditor()">
                                <i class="ai ai-plus"></i>
                                Create new hotel group
                            </base-button>

                            <el-popover
                                placement="left"
                                title="Filter hotel groups"
                                class="float-right"
                                popper-class="users-table-filter"
                                width="350"
                                trigger="click">
                                <base-button slot="reference" type="primary" outline class="filter-btn">
                                    <i class="m-0 ai ai-filter"></i>
                                    <i class="m-0 ai ai-angle-down"></i>
                                </base-button>
                                <el-form :model="filter" label-width="100px">
                                    <el-form-item label="Name">
                                        <el-input v-model="filter.name"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Short name">
                                        <el-input v-model="filter.short_name"></el-input>
                                    </el-form-item>
                                </el-form>
                            </el-popover>

                            <el-table
                                border
                                class="table-responsive table-flush"
                                header-row-class-name="thead-light"
                                :data="filteredData"
                                :empty-text="isLoadingHotelGroups ? 'Loading...' : 'No Data'"
                                lazy>

                                <el-table-column label="ID" prop="id" width="100" sortable></el-table-column>
                                <el-table-column label="Name" prop="name" sortable></el-table-column>
                                <el-table-column label="Short Name" prop="short_name" sortable></el-table-column>

                                <el-table-column label="actions" class-name="actions-column" width="130px">
                                    <template v-slot="{row}">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Edit hotel group"
                                            placement="top">
                                            <button
                                                type="button"
                                                @click="openHotelGroupEditor(row)"><i class="ai ai-edit text-yellow"></i>
                                            </button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Delete hotel group"
                                            placement="top">
                                            <button type="button" @click="deleteHotelGroupAttention(row)">
                                                <i class="ai ai-remove text-danger"></i>
                                            </button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <!--
                            <div class="card-footer py-4 d-flex justify-content-center">
                                <base-pagination v-model="currentPage"
                                                 :total="pageCount * itemsPerPage"></base-pagination>
                            </div>
                            -->
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <el-dialog
            title="Warning"
            :visible.sync="showDeleteHotelGroupAttentionModal"
            width="550px"
            center>
            <div class="h2 text-center">Are you sure you want to delete this hotel group: {{
                selectedHotelGroupForDelete.name }}?
            </div>
            <div slot="footer" class="dialog-footer">
                <base-button
                    outline
                    type="secondary"
                    @click="showDeleteHotelGroupAttentionModal = false">Cancel
                </base-button>
                <base-button type="danger" @click="deleteHotelGroup">Delete</base-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="selectedHotelGroup.id ? 'Edit hotel group' : 'Create a new hotel group'"
            :visible.sync="showHotelGroupEditorModal"
            width="550px"
            center
            @closed="closeHotelGroupEditor">
            <el-form>
                <el-form-item label="Hotel group name">
                    <el-input v-model="selectedHotelGroup.name"></el-input>
                </el-form-item>

                <el-form-item label="Hotel group short name">
                    <el-input v-model="selectedHotelGroup.short_name"></el-input>
                </el-form-item>

                <el-form-item label="Applications">
                    <el-checkbox-group v-model="relatedApps">
                        <el-checkbox
                            v-for="app in applications"
                            :key="app.id"
                            :label="app.name"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item
                    label="Billing by"
                    class="billing-by-selector">
                    <el-select
                        v-model="selectedHotelGroup.billing_by"
                        placeholder=" "
                        style="width: 100%">
                        <el-option label="Hotel group" value="hotel_group"></el-option>
                        <el-option label="Hotel" value="hotel"></el-option>
                    </el-select>
                </el-form-item>

                <div v-if="selectedHotelGroup.billing_by === 'hotel_group'">
                    <hr class="mb-2">
                    <h3>Billing data</h3>

                    <el-form-item label="Billingo Client Id">
                        <el-input v-model="selectedHotelGroup.billingo_id" type="number"></el-input>
                    </el-form-item>

                    <el-form-item label="Name">
                        <el-input v-model="selectedHotelGroup.billing_address.name"></el-input>
                    </el-form-item>

                    <el-form-item label="County">
                        <el-input v-model="selectedHotelGroup.billing_address.country"></el-input>
                    </el-form-item>

                    <el-form-item label="City">
                        <el-input v-model="selectedHotelGroup.billing_address.city"></el-input>
                    </el-form-item>

                    <el-form-item label="Postal code">
                        <el-input v-model="selectedHotelGroup.billing_address.postcode"></el-input>
                    </el-form-item>

                    <el-form-item label="Address">
                        <el-input v-model="selectedHotelGroup.billing_address.address"></el-input>
                    </el-form-item>
                </div>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <base-button outline type="warning" @click="closeHotelGroupEditor">Cancel</base-button>
                <base-button
                    type="success"
                    :disabled="!hotelGroupCanBeSave"
                    @click="saveHotelGroup">
                    <i class="ai ai-save"></i>
                    {{ selectedHotelGroup.id ? 'Save' : 'Add' }}
                </base-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import {BaseProgress} from '@/components'
    import RandomBackgroundColor from '@/mixins/random-background-color'
    import DeleteUserMixin from '@/mixins/delete-user'
    import {
        Table,
        TableColumn,
        DropdownMenu,
        DropdownItem,
        Dropdown,
        Pagination,
        Form,
        FormItem,
        Select,
        Option,
        Dialog,
        CheckboxGroup,
        Checkbox
    } from 'element-ui'

    export default {
        name: 'user-list',
        mixins: [RandomBackgroundColor, DeleteUserMixin],
        components: {
            BaseProgress,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Pagination.name]: Pagination,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Select.name]: Select,
            [Option.name]: Option,
            [Dialog.name]: Dialog,
            [CheckboxGroup.name]: CheckboxGroup,
            [Checkbox.name]: Checkbox,
        },
        data() {
            return {
                hotelGroups: [],
                applications: [],
                // currentPage: 0,
                // itemsPerPage: 10,
                // pageCount: 0,
                isLoadingHotelGroups: true,
                showDeleteHotelGroupAttentionModal: false,
                showHotelGroupEditorModal: false,
                selectedHotelGroup: {},
                relatedApps: [],
                selectedHotelGroupForDelete: {},
                filter: {
                    name: null,
                    shortName: null
                },
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser'
            }),
            filteredData: {
                get() {
                    const keys = Object.keys(this.filter);
                    let filteredHotelGroups = [...this.hotelGroups];
                    console.log('FILTER', this.filter);

                    // Filter by name
                    if (this.filter.name) {
                        filteredHotelGroups = filteredHotelGroups.filter(hg => hg.name.toLowerCase().includes(this.filter.name.toLowerCase()));
                    }

                    // Filter by email
                    if (this.filter.shortName) {
                        filteredHotelGroups = filteredHotelGroups.filter(hg => hg.shortName.toLowerCase().includes(this.filter.shortName.toLowerCase()));
                    }

                    // this.pageCount = Math.ceil(filteredHotelGroups.length / this.itemsPerPage) || 1;

                    /* Pagination START */
                    // const from = (this.currentPage - 1) * this.itemsPerPage;
                    // const to = from + this.itemsPerPage;
                    // filteredHotelGroups = filteredHotelGroups.slice(from, to);
                    /* Pagination END */

                    console.log('FFF', filteredHotelGroups)
                    return filteredHotelGroups;
                }
            },
            hotelGroupCanBeSave() {
                return this.selectedHotelGroup.name && this.selectedHotelGroup.short_name;
            }
        },
        methods: {
            deleteHotelGroupAttention(hotelGroup) {
                this.showDeleteHotelGroupAttentionModal = true;
                this.selectedHotelGroupForDelete = hotelGroup;
            },
            deleteHotelGroup() {
                this.$axios.delete('/api/admin/hotel-groups/' + this.selectedHotelGroupForDelete.id)
                    .then(res => {
                        this.hotelGroups = this.hotelGroups.filter(user => user.id !== this.selectedHotelGroupForDelete.id)
                        this.$notify({
                            title: 'Hotel group deleted',
                        });
                    })
                    .catch(({response}) => {
                        this.$notify({
                            title: response.data.message,
                            type: 'danger',
                        });
                    })
                    .then(() => {
                        this.showDeleteHotelGroupAttentionModal = false;
                        this.selectedUserForDelete = {};
                    })
            },
            openHotelGroupEditor(hotelGroup) {
                this.showHotelGroupEditorModal = true;
                this.relatedApps = hotelGroup ? hotelGroup.applications.map(hg => hg.name) : [];
                let selectedHotelGroup = JSON.parse(JSON.stringify(hotelGroup || {billing_by: 'hotel'}));
                selectedHotelGroup.billing_address = selectedHotelGroup.billing_address || {};
                this.selectedHotelGroup = selectedHotelGroup;
            },
            closeHotelGroupEditor() {
                this.showHotelGroupEditorModal = false;
                this.selectedHotelGroup = {};
                this.relatedApps = [];
            },
            saveHotelGroup() {
                this.selectedHotelGroup.relatedApps = this.applications.map(app => this.relatedApps.includes(app.name) ? app.id : null)
                    .filter(app => app);
                if (this.selectedHotelGroup.id) {
                    this.$axios.put('/api/admin/hotel-groups/' + this.selectedHotelGroup.id, this.selectedHotelGroup)
                        .then(res => {
                            const hotelGroup = res.data.data;
                            const hotelGroupIdx = this.hotelGroups.findIndex(hg => hg.id === hotelGroup.id);
                            this.hotelGroups[hotelGroupIdx] = hotelGroup;
                            this.hotelGroups = [...this.hotelGroups];
                            this.$notify({
                                title: 'Hotel group has updated',
                            });
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                        .then(() => {
                            this.closeHotelGroupEditor();
                        })
                } else {
                    this.$axios.post('/api/admin/hotel-groups', this.selectedHotelGroup)
                        .then(res => {
                            this.hotelGroups.unshift(res.data.data);
                            this.$notify({
                                title: 'New hotel group has added',
                            });
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                        .then(() => {
                            this.closeHotelGroupEditor();
                        })

                }
            },
        },
        async created() {
            this.hotelGroups = (await this.$axios.get('/api/admin/hotel-groups')).data.data;
            this.applications = (await this.$axios.get('/api/admin/applications')).data.data;
            console.log('CREATED', this.hotelGroups);

            this.isLoadingHotelGroups = false;
        },
    };
</script>
<style lang="scss">
    .list-users-page {
        .application-icon {
            display: inline-block;
            width: 36px;
            height: 36px;
            object-fit: cover;
            object-position: center center;
            cursor: default;

            &:not(:last-child) {
                margin-right: 5px;
            }

            &.text-icon {
                color: #fff;
                text-transform: uppercase;
                text-align: center;
                border-radius: 500px;
                line-height: 36px;
                font-size: 24px;
                vertical-align: middle;
            }
        }
    }

    .users-table-filter {
        .el-select {
            width: 100%;
        }
    }

    .billing-by-selector {
        &.is-error {
            .el-input__inner {
                border-color: #dcdfe6;
            }
        }
    }
</style>
